module.exports = __webpack_public_path__ + "img/mcgl_xsbj_06.6b9b91c8.png";